// @ts-nocheck

import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import './app.css';
import { Page } from './common/enums';
import LoginPage from './components/login';
import HomePage from './components/home/index';
import UnavailabilityPage from './components/unavailability';
import SliderLayout from './components/layout/SliderLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { inject, observer } from 'mobx-react';
import { AuthenticationStore } from './store';
import { Instance } from 'mobx-state-tree';
import UserListPage from './components/Users/UserListPage';
import UserPage from './components/User/UserPage';
import PharmaciesPage from './components/Pharmacies/PharmaciesPage';
import PharmacyPage from './components/Pharmacy';
import TransferPage from './components/Transfers';
import CalendarComparisonPage from './components/CalendarComparison';
import PlannerPage from './components/Planner';
import SecretariatListPage from './components/Secretariats/SecretariatListPage';
import AnalysisPage from './components/Analysis/AnalysisPage';
import SecretariatPage from './components/Secretariat/SecretariatPage';
import GroupPage from './components/Group/GroupPage';
import GroupListPage from './components/Groups/GroupListPage';
import ExchangePage from './components/Exchanges/ExchangePage';
import BankHolidayDatesPage from './components/BankHolidays/BankHolidayDatesPage';
import BlackPointsPage from './components/BlackPoints/BlackPointsPage';
import BlackPointPage from './components/BlackPoint';
import DutiesPage from './components/Duties';
import DutyAssignmentPage from './components/DutyAssignment';
import ErrorPage from './components/Error';
import UnauthorizedPage from './components/unAuthorized/unAuthorizedPage';
import SecretariatDashboard from './components/SecretariatDashboard/SecretariatDashboard';

const PageContainer = (props) => {
  return (
    <SliderLayout>
      {/* <Route exact={true} path={"/download"} component={Download} /> */}
      <Route path={Page.Home} component={HomePage} />
      <Route path={Page.Unavailable} component={UnavailabilityPage} />
      <Route strict={true} path={Page.Unauthorized} component={UnauthorizedPage} />
      <Route path={`${Page.Error}/:errorMessage`} component={ErrorPage} />
      <Route path={Page.BankHolidayDates} exact={true} component={BankHolidayDatesPage} />
      <Route path={Page.BlackPoints} exact={true} component={BlackPointsPage} />
      <Route path={`${Page.BlackPoints}/:blackPointId(-?\\d+)`} exact={true} component={BlackPointPage} />
      <Route path={Page.Exchanges} component={ExchangePage} />
      <Route path={Page.Duties} exact={true} component={DutiesPage} />
      <Route path={Page.DutyAssignment} component={DutyAssignmentPage} />
      <Route path={Page.CalendarComparisonPage} component={CalendarComparisonPage} />
      <Route path={`${Page.Duties}/:dutyId(-?\\d+)`} exact={true} component={() => <div>Duty edition here ! </div>} />
      <Route exact={true} path={Page.Planner} component={PlannerPage} />
      <Route path={Page.Pharmacies} exact={true} component={PharmaciesPage} />
      <Route path={Page.Transfers} exact={true} component={TransferPage} />
      <Route path={`${Page.PharmacyPage}/:pharmacyId(-?\\d+)`} exact={true} component={PharmacyPage} />
      <Route path={Page.Zones} component={() => <div>Zones</div>} />
      <Route path={Page.Users} component={UserListPage} />
      <Route exact={true} path={Page.UserPage} component={UserPage} />
      <Route exact={true} path={`${Page.UserPage}/:id`} component={UserPage} />
      <Route path={Page.Secretariats} component={SecretariatListPage} />
      <Route path={Page.Groups} component={GroupListPage} />
      <Route path={Page.Diagnostic} component={AnalysisPage} />
      <Route exact={true} path={Page.SecretariatPage} component={SecretariatPage} />
      <Route exact={true} path={`${Page.SecretariatPage}/:id`} component={SecretariatPage} />
      <Route exact={true} path={`${Page.GroupPage}/:id`} component={GroupPage} />
      <Route exact={true} path={Page.SecretariatDashboard} component={SecretariatDashboard} />
    </SliderLayout>
  );
};

interface AppProps extends RouteComponentProps<string> {
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
}

@inject('AuthenticationStore')
@observer
class App extends React.Component<AppProps> {
  render() {
    console.log('>>> RENDERING MAIN APP ' + new Date());
    const { AuthenticationStore } = this.props;
    return (
      <div className={'App'}>
        <Switch>
          <Redirect exact={true} from={'/'} to={Page.Home} />
          <Route strict={true} path={Page.Login} component={LoginPage} />
          <ProtectedRoute
            isAuthenticated={AuthenticationStore!.isAuthenticated()}
            userHasActions={AuthenticationStore!.userHasActions}
            path={'/'}
            render={() => <Route component={PageContainer} />}
          />
        </Switch>
      </div>
    );
  }
}

const RoutedApp = withRouter(App);
export default RoutedApp;
